import {
  getSearchHistoryElectronicDocument,
  getTabValue,
  Layout,
  saveSearchHistoryElectronicDocument,
} from "shared/utils";
import { useNavigate } from "react-router-dom";
import { FormReadDocument } from "./components/FormReadDocument";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch, RootState } from "shared/store/store";
import { Spinner } from "shared/components/Spinner";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { apiInstance } from "shared/api/config/apiInstance";
import { GET_DATA_PROVIDER } from "shared/api";
import { TableComponent } from "shared/components/Table.component";
import { ComboBoxCustom, CustomTabs, RouterGuard } from "shared/components";
import { useTableResults } from "../../shared/hooks/useTableResults";
import { accesRoles } from "shared/models";
import { columnsTable, fieldsForm, columnsTableTransform } from "./helper";
import { columnsCreditNote } from "./helper/columnsCreditNote";
import { ModalDocumentsPdf } from "shared/components/ModalDocuments.pdf";
import { useOpenPdf } from "shared/hooks/useOpenPdf";
import { useModalLoadRipsFiles } from "shared/hooks/Modals/useModalLoadRipsFiles";
import styles from "./styles/tableResults.module.scss";
import { HeaderSearch } from "shared/components/table/components/HeaderSearch";

export const ReadDocuments = () => {
  const dispatch = useDispatch<Dispatch>();
  const navigate = useNavigate();
  const electronicDocuments = useSelector(
    (state: RootState) => state.electronicDocuments,
  );
  const optionsDropdowns = useSelector(
    (state: RootState) => state.optionsDropdowns,
  );
  const consolidateGlosas = useSelector(
    (state: RootState) => state.consolidateGlosas,
  );
  const { loading } = useSelector(
    (rootState: RootState) => rootState.loading.models.electronicDocuments,
  );
  const { sumValuesAllValueNotAccept } = consolidateGlosas;
  const [isBillValueNotAccept, setIsBillValueNotAccept] = useState(false);
  const [dataProvider, setDataProvider] = useState(null);
  const [dataFields, setDataFields] = useState<any[]>([]);
  const [isSearch, setIsSearch] = useState(true);
  const [makeHttpRequest, setMakeHttpRequest] = useState(false);
  const dataLocalStorage = useMemo(
    () => getSearchHistoryElectronicDocument(),
    [localStorage],
  );
  const { content, contentSize, totalElements } = electronicDocuments;

  const {
    paramsUrl,
    rowSelected,
    dataMassiveAssigment,
    activateDropDown,
    actionModalAbortDE,
    actionModalResetAudit,
    handleSelectAllClick,
    handleChangeCheck,
    handleUserAssignment,
    linkToDian,
    handleMassiveAssignment,
    validateUserAuditor,
    validateEqualStates,
  } = useTableResults();

  const { documentPdf, openIframePdf, isLoading, closeModalPdf } = useOpenPdf();
  const { showModal, isLoading: LoadingDocumentRips } = useModalLoadRipsFiles();

  const valuesResultsPages = [50, 100, 150, 200];

  const optionsTrazact = (id: string) => {
    return (
      <RouterGuard roles={accesRoles.usersSSSA} type="component">
        <ComboBoxCustom
          handleChange={handleMassiveAssignment}
          idsDoc={rowSelected}
          data={dataMassiveAssigment}
          placeholder="Asignar"
          isDisabled={activateDropDown || validateUserAuditor()}
          useButtonIcon
          idComboBoxCustom={id}
        />
      </RouterGuard>
    );
  };

  useEffect(() => {
    validateEqualStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowSelected]);

  useEffect(() => {
    async function fetchData() {
      const response = await apiInstance.get(GET_DATA_PROVIDER);
      setDataProvider(response.data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    const fields = fieldsForm(optionsDropdowns);
    setDataFields(fields);
  }, [optionsDropdowns]);

  useEffect(() => {
    const billNotAccept = sumValuesAllValueNotAccept <= 0;
    setIsBillValueNotAccept(!billNotAccept);
  }, [sumValuesAllValueNotAccept]);

  useEffect(() => {
    dispatch.optionsDropdowns.getUsers();
    dispatch.optionsDropdowns.getTypesDocuments();
    dispatch.optionsDropdowns.getDepartments();
    dispatch.optionsDropdowns.getActivityStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    electronicDocuments.content && setMakeHttpRequest(true);
  }, []);

  useEffect(() => {
    if (dataLocalStorage && makeHttpRequest) {
      const { params, url } = dataLocalStorage;
      const { origin, filter } = params || {};
      if (filter) {
        dispatch.searcher.addText(filter);
      }

      if (origin === "MENU" || origin !== "MENU") {
        const paramsWithSize = { ...params, size: "50" };
        dispatch.electronicDocuments.getElectronicDocuments(
          paramsWithSize,
          url,
        );
      }
    }
  }, [makeHttpRequest, dataLocalStorage]);

  const getElectronicDocumentsTabs = useCallback(
    (typeDocument: string) => {
      setIsSearch(false);
      dispatch.searcher.addText("");
      const { url, paramsUrl: paramsUrlElectonic } = electronicDocuments;
      const newParams = {
        ...paramsUrlElectonic,
        typeDocument,
        filter: null,
        size: "50",
      };
      dispatch.electronicDocuments.getElectronicDocuments(newParams, url);
      saveSearchHistoryElectronicDocument({
        params: {
          ...newParams,
          filter: "",
        },
        url,
      });
    },
    [electronicDocuments],
  );

  const callGetFileExcelToExport = () => {
    dispatch.electronicDocuments.getFileExcelToExport({
      urlByParams: electronicDocuments.url?.slice(
        electronicDocuments.url.indexOf("?") + 1,
      ),
      paramsUrl,
      text: "Archivo excel descargado",
    });
  };

  const callGetFileExcelToImport = () => {
    navigate("/consulta_documentos_electronicos/cargar_soportes_pagos");
  };

  const startIconContent = optionsTrazact?.("table-facturas");

  const isDisabledButtonTraza = React.useMemo(
    () => rowSelected?.length === 0,
    [rowSelected],
  );

  const buttonClassName = `${
    isDisabledButtonTraza ? styles.disabledButton : ""
  } ${styles.buttons}`.trim();

  const shouldDisplayFlex =
    optionsTrazact === undefined || callGetFileExcelToExport === undefined;

  const getSectionClassName = () => {
    const baseClass = styles.contentButtonMobil;
    const flexClass = shouldDisplayFlex ? styles["displayFlex"] : "";
    return `${baseClass} ${flexClass}`.trim();
  };

  const component = (idTable: string) => {
    return (
      <TableComponent
        columns={columnsTableTransform(
          columnsCreditNote({ onAction: showModal, dispatch }),
        )}
        valuesResultsPages={valuesResultsPages}
        downloadExcel={callGetFileExcelToExport}
        uploadExcel={callGetFileExcelToImport}
        isDisabledButtonTraza={activateDropDown || validateUserAuditor()}
        isStyleActivity={false}
        idTable={idTable}
        isSearch={isSearch}
        showBtnCollapse={false}
      />
    );
  };

  const renderHeaderSearch = () => {
    return (
      <HeaderSearch
        buttonClassName={buttonClassName}
        content={content}
        contentSize={contentSize}
        downloadExcel={callGetFileExcelToExport}
        uploadExcel={callGetFileExcelToImport}
        isDisabledButtonTraza={isDisabledButtonTraza}
        getSectionClassName={getSectionClassName}
        idTable={"table-facturas"}
        optionsTrazact={optionsTrazact}
        props={{}}
        startIconContent={startIconContent}
        totalElements={totalElements}
        widthSearchFull={false}
      />
    );
  };

  return (
    <Layout>
      {electronicDocuments.content ? (
        <CustomTabs
          tabProps={[
            {
              label: "Facturas",
              component: (
                <TableComponent
                  columns={columnsTableTransform(
                    columnsTable(
                      {
                        linkToDian,
                        actionModalAbortDE,
                        actionModalResetAudit,
                        isBillValueNotAccept,
                        paramsUrl,
                      },
                      handleUserAssignment,
                      validateUserAuditor,
                    ),
                    ["filedAt"],
                  )}
                  valuesResultsPages={valuesResultsPages}
                  optionsTrazact={optionsTrazact}
                  rowSelected={rowSelected}
                  downloadExcel={callGetFileExcelToExport}
                  uploadExcel={callGetFileExcelToImport}
                  selectAllRows={handleSelectAllClick}
                  selectRow={handleChangeCheck}
                  isDisabledButtonTraza={
                    activateDropDown || validateUserAuditor()
                  }
                  isStyleActivity={true}
                  idTable="table-facturas"
                  isSearch={isSearch}
                  showBtnCollapse={false}
                />
              ),
              title: "Gestión de trazabilidad de factura",
              callService(typeDocument) {
                getElectronicDocumentsTabs(String(typeDocument + 1));
              },
              renderHeaderSearch: renderHeaderSearch,
            },
            {
              label: "Notas Crédito",
              component: component("table-notas-credito"),
              title: "Gestión de Notas Crédito",
              callService(typeDocument) {
                getElectronicDocumentsTabs(String(typeDocument + 1));
              },
              renderHeaderSearch: renderHeaderSearch,
            },
            {
              label: "Notas Débito",
              component: component("table-notas-debito"),
              title: "Gestión de Notas Débito",
              callService(typeDocument) {
                getElectronicDocumentsTabs(String(typeDocument + 1));
              },
              renderHeaderSearch: renderHeaderSearch,
            },
          ]}
          hasStyleCustomTabs={true}
          valueTab={getTabValue(electronicDocuments, dataLocalStorage) - 1}
        />
      ) : (
        <FormReadDocument dataProvider={dataProvider} dataFields={dataFields} />
      )}

      {(loading || isLoading || LoadingDocumentRips) && <Spinner />}
      {openIframePdf && (
        <ModalDocumentsPdf
          document={documentPdf}
          openIframePdf={openIframePdf}
          handleOpenIframePdf={closeModalPdf}
        />
      )}
    </Layout>
  );
};
